import { useState, useEffect, useRef } from "react";
import Select from "react-select";
import { Plus, Minus, Trash2, Info, } from "lucide-react";
import Modal from "react-modal";
import { extras, descripcionesPlatos } from ".//Utils/DescripcionesPlatos";
import { nanoid } from "nanoid";
import { customStyles, ModalAnimado } from "./Utils/CustomStyles";
import { showSuccess, showError,showInfo } from "./Utils/toastUtils";
import { useItems } from "../Hooks/useItems";
import Blank from "../img/ImgProducts/Black.webp"
import { FaTimes } from "react-icons/fa";

Modal.setAppElement("#root");

const opcionesPlatos = Object.keys(extras).map((nombre) => ({
  label: nombre,
  value: nombre,
}));

const PlatoSelectorExtras = ({ onSeleccion, platosDisponibles = [] }) => {
   
  const platosNotificados = useRef(new Set());
  const [modalPlato, setModalPlato] = useState(null);
  const [platoTemporal, setPlatoTemporal] = useState(null);
  const [imagenAmpliada, setImagenAmpliada] = useState(false);
  const [abrirModalId, setAbrirModalId] = useState(null);
  const [selectedOption, setSelectedOption] = useState(null);
  const {platosSeleccionados, setPlatosSeleccionados, aumentarCantidad, disminuirCantidad, eliminarItem } = useItems("extrasSeleccionados");
  

  useEffect(() => {
    onSeleccion(platosSeleccionados);
    localStorage.setItem("extrasSeleccionados", JSON.stringify(platosSeleccionados));
  }, [platosSeleccionados, onSeleccion]);

  useEffect(() => {
  if (abrirModalId) {
    const existe = platosSeleccionados.some(p => p.id === abrirModalId);
    if (existe) {
      setModalPlato(abrirModalId);
      setAbrirModalId(null);
    }
  }
}, [platosSeleccionados, abrirModalId]);


  const agregarOActualizarPlato = (platoNombre) => {
    if (extras[platoNombre]?.disponible !== true) {
      showInfo && showInfo('Este producto no está disponible');
      return;
    }

    if (extras[platoNombre]?.modal && platosDisponibles.length === 0) {
      showError("Debes seleccionar al menos un plato para agregar este extra.");
      return;
  }

  const precio = extras[platoNombre]?.precio || "0";
  const nuevoId = nanoid();

  // Buscar si este plato pertenece a un barco o sushi torta
  let extraAplicado = "";

  for (const item of platosDisponibles) {
    if (item.platos && Array.isArray(item.platos)) {
      const encontrado = item.platos.find((pl) => pl.nombre === platoNombre);
      if (encontrado) {
        const tipo = item.tipo?.toLowerCase().includes("sushi") ? "Sushi Torta" : "Barco";
        extraAplicado = `${tipo} - ${item.tamaño} piezas`;
        break;
      }
    }
  }
  const descripcionPlato = descripcionesPlatos[platoNombre] || {};
  const productoImg = descripcionPlato.productoImg || Blank;

  const nuevoPlatoTemporal = {
    id: nuevoId,
    nombre: platoNombre,
    cantidad: 1,
    precio,
    extraAplicado,
    productoImg // ahora puede ser vacío o "Barco - 30 piezas", etc.
  };

  setPlatoTemporal(nuevoPlatoTemporal);

  if (extras[platoNombre]?.modal) {
    setModalPlato(nuevoId);
  } else {
    setPlatosSeleccionados((prev) => [...prev, nuevoPlatoTemporal]);

    if (!platosNotificados.current.has(nuevoId)) {
      showSuccess(`"${platoNombre}" agregado `);
      platosNotificados.current.add(nuevoId);
    }
  }
  };

 const cerrarModal = () => {
  if (!modalPlato || !platoTemporal) return;

  const { id, nombre, extraAplicado } = platoTemporal;

 

  if (!extraAplicado || extraAplicado === "") {
    showError("Debes seleccionar un plato");
    return;
  }

  // 🔍 Buscar la imagen del plato seleccionado en descripcionesPlatos
  // extraAplicado puede ser un nombre de plato o "Barco/Sushi Torta - XX piezas"
  let productoImg = Blank;

  if (descripcionesPlatos[extraAplicado]?.productoImg) {
    productoImg = descripcionesPlatos[extraAplicado].productoImg;
  } else if (descripcionesPlatos[nombre]?.productoImg) {
    // fallback por si no encuentra extraAplicado
    productoImg = descripcionesPlatos[nombre].productoImg;
  }

  // Construir el objeto final del plato con imagen incluida
  const platoFinal = {
    ...platoTemporal,
    productoImg
  };

  // Actualizar la lista de platos seleccionados
  setPlatosSeleccionados((prev) => {
    const existe = prev.some((p) => p.id === id);
    return existe
      ? prev.map((p) => (p.id === id ? platoFinal : p))
      : [...prev, platoFinal];
  });

  // Mostrar notificación si aún no se había agregado
  if (!platosNotificados.current.has(id)) {
    showSuccess(`"${nombre}" agregado`);
    platosNotificados.current.add(id);
  }

  // Limpiar modal y temporal
  setModalPlato(null);
  setPlatoTemporal(null);
};


  const actualizarCheckboxPlatoTemporal = (campo, valor) => {
    setPlatoTemporal((prev) => ({
      ...prev,
      relleno: campo === "relleno" ? valor : false,
      topping: campo === "topping" ? valor : false,
    }));
  };
  
  const actualizarCheckboxPlato = (id, campo, valor) => {
  setPlatosSeleccionados((prev) =>
    prev.map((plato) => {
      if (plato.id !== id) return plato;

      // Si cambio relleno/topping, apago el otro
      if (campo === "relleno") {
        return { ...plato, relleno: valor, topping: false };
      }
      if (campo === "topping") {
        return { ...plato, topping: valor, relleno: false };
      }
      if (campo === "extraAplicado") {
        return { ...plato, extraAplicado: valor };
      }

      return plato;
    })
  );
};

  const platoActual = platoTemporal;

  const handleSelect = (opt) => {
    if (!opt) return;
    agregarOActualizarPlato(opt.value);
    setSelectedOption(null); // Reinicia el Select
  };

   const forzarCerrarModal = () => {
    setModalPlato(null);
  };


  return (
  <div className="max-w-xl mx-auto mb-3"> {/* Agregué padding para móvil */}

    {/* Primer Select real React-Select */}
    <Select
      options={opcionesPlatos}
      styles={customStyles}
      placeholder="Selecciona un Extra"
      onChange={handleSelect}
      menuPlacement="auto"
    />

    <div className="space-y-4 mt-4">
      {platosSeleccionados.map((plato) => (
        <div
          key={plato.id}
          className="relative rounded-lg overflow-hidden shadow-md"
        >
          {/* Imagen de fondo */}
          <div
            className="absolute inset-0 bg-center bg-cover"
            style={{ backgroundImage: `url(${plato.productoImg || Blank})` }}
          />

          {/* Overlay oscuro */}
          <div className="absolute inset-0 bg-black/40" />

          {/* Contenido sobre la imagen */}
          <div className="relative p-4 space-y-2 text-white">
            {/* Nombre + Botón info */}
            <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between">
              <h3 className="font-extrabold text-xl flex items-center justify-between sm:justify-start">
                {plato.nombre}
                {extras[plato.nombre]?.modal && (
                  <button
                    onClick={() => {
                      const disponible = extras[plato.nombre]?.disponible;
                      if (!disponible) {
                        showInfo && showInfo('Este producto no está disponible');
                        return;
                      }
                      const seleccionado = platosSeleccionados.find((p) => p.id === plato.id);
                      if (seleccionado) {
                        setPlatoTemporal({ ...seleccionado });
                        setModalPlato(plato.id);
                      }
                    }}
                    className="ml-2 text-white hover:text-gray-300"
                    aria-label={`Información de ${plato.nombre}`}
                  >
                    <Info size={18} />
                  </button>
                )}
              </h3>

              {/* Botones cantidad y eliminar */}
              <div className="flex items-center justify-center space-x-2 mt-2 sm:mt-0">
                <button
                  onClick={() => disminuirCantidad(plato.id, showSuccess)}
                  className="p-1 hover:text-gray-200"
                >
                  <Minus size={18} />
                </button>
                <button
                  onClick={() => aumentarCantidad(plato.id, showSuccess)}
                  className="p-1 hover:text-gray-200"
                >
                  <Plus size={18} />
                </button>
                <button
                  onClick={() => eliminarItem(plato.id, showSuccess)}
                  className="p-1 text-white hover:text-red-700"
                >
                  <Trash2 size={18} />
                </button>
              </div>
            </div>

            {/* Cantidad */}
            <p className="text-sm mt-2">Cantidad: {plato.cantidad}</p>

            {/* Select de extraAplicado (se mantiene lógica y renderizado) */}
            {extras[plato.nombre]?.modal && (
              plato.extraAplicado && (
                <div className="mt-3">
                  <Select
                    options={platosDisponibles.map((pl) => ({
                      value: pl.nombre,
                      label: pl.nombre,
                    }))}
                    value={(() => {
                      const opt = platosDisponibles.find(
                        (pl) => pl.nombre === plato.extraAplicado
                      );
                      return opt ? { value: opt.nombre, label: opt.nombre } : null;
                    })()}
                    onChange={(selected) =>
                      actualizarCheckboxPlato(
                        plato.id,
                        "extraAplicado",
                        selected ? selected.value : ""
                      )
                    }
                    placeholder="Seleccione un plato"
                    styles={customStyles}
                    menuPlacement="auto"
                    isSearchable={false}
                  />
                </div>
              )
            )}
          </div>
        </div>
      ))}
    </div>

    <ModalAnimado isOpen={!!modalPlato} onClose={cerrarModal}>
  <div className="relative z-10 flex flex-col h-full">

    {/* Encabezado: nombre del plato principal + botón cerrar */}
    <div className="flex justify-between items-center p-4">
      <h2 className="text-xl font-bold text-yellow-400 drop-shadow-lg">
        {platoTemporal?.nombre} {/* Nombre del plato principal */}
      </h2>
      <button
        onClick={forzarCerrarModal}
        className="bg-yellow-400 hover:bg-white/50 transition rounded-xl w-9 h-9 flex items-center justify-center text-xl text-white/80 font-bold"
      >
        <FaTimes className="text-white text-2xl" />
      </button>
    </div>

    {/* Contenedor general */}
    <div className="flex-1 flex flex-col relative px-5">

      {/* Select de extraAplicado */}
      {extras[platoTemporal?.nombre]?.modal && (
        <div className="mt-6">
          <Select
            options={platosDisponibles.map(pl => ({ value: pl.nombre, label: pl.nombre }))}
            value={platoTemporal?.extraAplicado ? { value: platoTemporal.extraAplicado, label: platoTemporal.extraAplicado } : null}
            onChange={selected => setPlatoTemporal(prev => ({
              ...prev,
              extraAplicado: selected ? selected.value : ""
            }))}
            placeholder="Seleccione un plato"
            styles={customStyles}
            menuPlacement="auto"
            isSearchable={false}
          />
        </div>
      )}

      {/* Imagen del producto seleccionado */}
      {platoTemporal?.extraAplicado && (
        <div className="relative w-full flex justify-center mt-6">
          <img
            src={descripcionesPlatos[platoTemporal.extraAplicado]?.productoImg || Blank}
            alt={platoTemporal.extraAplicado}
            className="h-52 sm:h-60 object-contain drop-shadow-lg rounded-lg"
          />
          <div className="absolute -bottom-1 w-auto text-center bg-gradient-to-t from-white via-white/80 to-transparent py-3 rounded-b-xl">
            <h2 className="text-2xl sm:text-3xl font-extrabold uppercase text-yellow-400 drop-shadow-lg">
              {platoTemporal.extraAplicado}
            </h2>
          </div>
        </div>
      )}

    </div>

    {/* Footer con precio y agregar */}
    <div className="w-full flex justify-between items-center py-4 border-t-2 border-gray-300 mt-3 px-5">
      <span className="text-2xl font-extrabold text-yellow-400 drop-shadow-md">
        ${platoTemporal?.precio || extras[platoTemporal?.nombre]?.precio || 0}
      </span>
      <button
        onClick={cerrarModal}
        className="px-6 py-2 bg-yellow-500 shadow-xl text-lg text-white font-extrabold rounded-xl"
      >
        Agregar
      </button>
    </div>
  </div>
</ModalAnimado>


  </div>
);


};

export default PlatoSelectorExtras;
